import { render, staticRenderFns } from "./PlatformProfilePanel.vue?vue&type=template&id=567b5c4a&scoped=true"
import script from "./PlatformProfilePanel.vue?vue&type=script&lang=js"
export * from "./PlatformProfilePanel.vue?vue&type=script&lang=js"
import style0 from "./PlatformProfilePanel.vue?vue&type=style&index=0&id=567b5c4a&prod&lang=scss&scoped=true"
import style1 from "./PlatformProfilePanel.vue?vue&type=style&index=1&id=567b5c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b5c4a",
  null
  
)

export default component.exports